export default __webpack_public_path__ + "static/media/3.7585e22f.jpg";